import React, { useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { apiRequest } from "../utils/apiRequest";
import { useAuthHeaders } from "../utils/getHeaders";
import { DEACTIVATEACCOUNT } from "../rest/endpoints";
import { useSelector } from "react-redux";

const DeactivateAccount = () => {
  const [reason, setReason] = useState("");
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [showForm, setShowForm] = useState(true);
  const navigate = useNavigate();
  const headers = useAuthHeaders();

  const translations = useSelector((state) => state.language.translations);

  const handleDeactivate = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await apiRequest({
        url: DEACTIVATEACCOUNT,
        method: "POST",
        data: { reason },
        headers,
      });

      setResponseMessage(
        response?.data.message || translations.willBeDeactivated
      );

      console.log(responseMessage);

      setShowForm(false);
      localStorage.clear();
      setTimeout(() => {
        // navigate("/");
      }, 5000);
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
          "Failed to deactivate account. Please try again."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!showForm) {
    return (
      <div className="min-h-screen bg-light-pink pt-16 sm:pt-0">
        <div className="w-full sm:min-h-screen sm:flex sm:items-center sm:justify-center p-4">
          <div className="bg-custom-beige rounded-[24px] shadow-lg overflow-hidden max-w-2xl w-full p-8">
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-gray-100 flex items-center justify-center">
                <svg
                  className="w-8 h-8 text-gray-500"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>

              <h2 className="text-2xl font-semibold text-gray-800 mb-2">
                {translations.accountDeactivationRequestReceived}
              </h2>
              <div className="w-24 h-1 bg-custom-orange mx-auto mb-6"></div>

              <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-8 mb-6">
                <p className="text-gray-700 text-lg leading-relaxed">
                  {responseMessage}
                </p>
              </div>

              <div className="space-y-4">
                <p className="text-gray-600">{translations.thankYou}</p>
                <div className="flex items-center justify-center space-x-2 text-sm text-gray-500">
                  <svg
                    className="w-4 h-4 animate-spin"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                    />
                  </svg>
                  <span>{translations.redirectingToHomepage}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-light-pink pt-16 sm:pt-0">
      <div className="w-full sm:min-h-screen sm:flex sm:items-center sm:justify-center p-4">
        <div className="bg-custom-beige rounded-[24px] shadow-lg overflow-hidden max-w-2xl w-full p-8">
          <h1 className="text-3xl font-bold text-custom-maroon mb-2">
            {translations.deactivateYourAccount}
          </h1>
          <p className="text-gray-600 mb-8">{translations.sorryToSeeYouGo}</p>

          <ul className="list-disc list-inside mb-8 text-gray-600 space-y-2">
            <li>{translations.disableAccessToPlatform}</li>
            <li>{translations.removePersonalPreferences}</li>
          </ul>

          <form onSubmit={handleDeactivate} className="space-y-6">
            <div>
              <label
                htmlFor="reason"
                className="block text-sm font-medium text-gray-700 mb-2"
              >
                {translations.whyleaving}
              </label>
              <textarea
                id="reason"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-custom-orange focus:border-transparent"
                rows="4"
                placeholder={translations.feedback}
                required
              />
            </div>

            <div className="flex items-start">
              <div className="flex items-center h-5">
                <input
                  id="confirmation"
                  type="checkbox"
                  checked={isConfirmed}
                  onChange={(e) => setIsConfirmed(e.target.checked)}
                  className="h-4 w-4 text-custom-orange border-gray-300 rounded focus:ring-custom-orange"
                />
              </div>
              <label
                htmlFor="confirmation"
                className="ml-2 block text-sm text-gray-600"
              >
                {translations.iUnderstandDeactivationIsPermanent}
              </label>
            </div>

            <div className="flex gap-4">
              <button
                type="button"
                onClick={() => navigate("/")}
                className="flex-1 px-4 py-3 border border-custom-orange text-custom-orange rounded-lg hover:bg-gray-50 font-medium transition-colors"
              >
                {translations.cancel}
              </button>
              <button
                type="submit"
                disabled={isSubmitting || !isConfirmed}
                className={`flex-1 px-4 py-3 rounded-lg font-medium text-white transition-colors
                  ${
                    isSubmitting || !isConfirmed
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-custom-orange hover:bg-orange-600"
                  }`}
              >
                {isSubmitting
                  ? translations.processing
                  : translations.deactivateMyAccount}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default DeactivateAccount;
